import * as queryKeys from "@/data/constant/queryKeys";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useYongchaData = (search?: any, enabled?: boolean) => {
  return useQuery<any[]>({
    queryKey: [queryKeys.YONGCHASA_DATA, search],
    queryFn: () =>
      request({
        method: "GET",
        url: `/companyManage/lookup/isYongchasa`,
        params: search,
      }),
    enabled: enabled,
  });
};

export default useYongchaData;
